module.exports = __webpack_public_path__ + "img/osredmLogo-white.dea9dc57.svg";